var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pic-box"},[_c('swiper',{ref:"swiperTop",staticClass:"gallery-top",staticStyle:{"width":"600px"},attrs:{"options":_vm.swiperOptionTop}},_vm._l((_vm.imgList),function(item,index){return _c('swiper-slide',{key:index},[_c('img',{staticClass:"pic-view",attrs:{"src":item,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }